import React from "react";
import { observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";


const DeleteNotificationsModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    function closeModal() {
        modalStore.isDeleteNotificationsModalOpen = false;
        modalStore.resetModalData();
    }

    async function deleteNotifications() {
        try {
            generalStore.isLoaderOpen = true;
            await modalStore.modalData.action(modalStore.modalData.arg)
            closeModal()
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('problemDeletingNotifications'));
            console.error(e);
        }
        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isDeleteNotificationsModalOpen'
            className='delete-dialog'
            onEnter={null}
            title={modalStore.modalData.title}
            body={<div className="dialog-description">{modalStore.modalData.message}</div>}
            isConfirmDisabled={false}
            onConfirm={deleteNotifications}
            confirmText={generalStore.translate('delete')}
        />
    );
});

export default DeleteNotificationsModal;
